import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useICartridge from "../../../context/hooks/useICartridge";
import { PaginationComponent } from "../../../monsterComponents/components/paginationComponent";
import { DevicesList } from "../../../monsterComponents/lists/devicesList";
import { getClientsList } from "../../../services/clientService";
import { getDevices } from "../../../services/deviceService";
import { ErrorHelper } from "../../../utils/ErrorHelper";

export const Devices = (props) => {
    const [devices, setDevices] = useState([]);
    const [pagination, setPagination] = useState({ currentPage: 1, count: 0, totalPages: 0 });
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [isAdminRole, setIsAdminRole] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const { user } = useICartridge();

    useEffect(() => {
        (async () => {
            try {
                await props.handleRefreshToken();

                // set users and clients drop down values for admins and clients manager
                if (user != null && (user.isAdmin || user.isClientManager)) {
                    setIsAdminRole(true);
                    let clients = await getClientsList();
                    setClients(clients);
                    let devices = await getDevices(selectedClient.value, pagination.currentPage);
                    setDevices(devices.data);

                    setPagination({
                        currentPage: devices.pagination.currentPage,
                        count: devices.pagination.count,
                        totalPages: devices.pagination.totalPages,
                    });
                }
                //set devices for just editor users
                else if (user != null && !user.isAdmin && !user.isClientManager) {
                    let devices = await getDevices(null, pagination.currentPage);
                    setDevices(devices.data);
                }

                setIsLoading(false);
            } catch (error) {
                toast.error(ErrorHelper(error).errors[0]);
                setIsLoading(false);
            }
        })();
    }, [pagination.currentPage, selectedClient])

    return (
        <div className="page-content container-fluid">
            <DevicesList
                devicesList={devices}
                clients={clients}
                selectedClient={selectedClient}
                setSelectedClient={setSelectedClient}
                isAdminRole={isAdminRole}
                isLoading={isLoading}
            />
            <PaginationComponent
                pagination={pagination}
                setPagination={setPagination}
            />
        </div>
    );
}